// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAJhF9PR8fWz4ZYeQgonZKT9nEfw8dbY9M',
  authDomain: 'amt-logistics.firebaseapp.com',
  projectId: 'amt-logistics',
  storageBucket: 'amt-logistics.appspot.com',
  messagingSenderId: '1082234296385',
  appId: '1:1082234296385:web:abf9f70c7cf6525a388ec0',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
export { auth, db, storage, analytics };
